import { useSelector } from 'react-redux';
import { ACCESS_DENIED_MESSAGES } from '../constants/accessDenied';

export function useAccessDeniedMessage(templateKey = 'action_denied') {
  const rootUserEmail = useSelector((state) => state.org.org?.root_user_email ?? '');
  const template = ACCESS_DENIED_MESSAGES[templateKey] ?? ACCESS_DENIED_MESSAGES.action_denied;
  const email = (rootUserEmail ?? '').trim();

  return template.replace('{email}', email || 'your organization admin');
}
